// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2bG-x","inputWrap":"CustomTip_inputWrap__3IjEx"};